import axios from 'axios'
import { CORRESPONDENTS_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getCorrespondent = (accountNumber: string) =>
  axios.get(
    `${CORRESPONDENTS_API}?account=${accountNumber}`,
    WITH_CREDENTIALS_CONFIG
  )
